"use client";
import { useEffect, useState } from "react";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { Modal } from "@/utils/bootstrap";
import SvgModalClose from "./SvgModalClose";
import CustomButton, { BtnRadius, BtnSizes, BtnTypes } from "./CustomButton";
import { useTranslation } from "@/hooks/localization/useTranslations";
import useSellingMode from "@/hooks/useSellingMode";

const CartDisabled = () => {
  const t = useTranslation();
  const getCompany = useGetCompanyQuery();
  const { enableSells } = useSellingMode();
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (getCompany.isLoading) return;
    const settings = getCompany?.data?.result?.theme?.settings;
    const { show_cart } = settings!;

    if (!show_cart) return;
    setShow(!enableSells);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCompany.isLoading]);
  if (!show) return null;
  return (
    <div className={`${show && "backdrop-with-blur"}`}>
      <Modal
        centered
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="messagebox-dialog"
        contentClassName="messagebox-cart-disabled"
      >
        <div className="messagebox-closeicon">
          <SvgModalClose onClick={() => setShow(false)} />
        </div>
        <div className="messagebox-title">{t.cart_disabled}</div>
        <div className="messagebox-message" style={{ textAlign: "center" }}>
          {t.we_paused_purchasing}
        </div>
        <CustomButton
          type={BtnTypes.primary}
          size={BtnSizes.medium}
          radius={BtnRadius.small}
          onClick={() => setShow(false)}
          fullWidth
        >
          {t.ok_continue_browsing}
        </CustomButton>
      </Modal>
    </div>
  );
};

export default CartDisabled;
